module.exports = new __parcel__URL__("click.7ec3aeb0.wav").toString();